import React, { useState, useEffect } from "react";
import "./nav-admin.css";
import UploadUsersIcon from "../../assets/images/svg-icons-material-io/group_add_FILL0_wght400_GRAD0_opsz48.svg";
import UploadStatusIcon from "../../assets/images/svg-icons-material-io/drive_folder_upload_FILL0_wght400_GRAD0_opsz48.svg";
import ReceivedMsgIcon from "../../assets/images/svg-icons-material-io/markunread_mailbox_FILL0_wght400_GRAD0_opsz48.svg";
import AddOrgCustomersIcon from "../../assets/images/svg-icons-material-io/domain_add_FILL0_wght400_GRAD0_opsz48.svg";
import { Link } from "react-router-dom";
import SubMenuModal from "./SubMenu/SubMenuModal";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

const NavAdmin = () => {
  const {
    userRole,
    setCustomerObj,
    setCustomerFlag,
    setSearchObj,
    SetSharedObject,
    userSession,
    backendTarget,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    setCustomerObj: state.setCustomerObj,
    setCustomerFlag: state.setCustomerFlag,
    setSearchObj: state.setSearchObj,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
    backendTarget: state.backendTarget,
  }));
  const isGcpUser = !!userSession?.is_gcp_user || backendTarget === "gcp";
  const [createUser, setCreateUser] = useState(false);
  useEffect(() => {
    setCreateUser(
      userSession?.CreateUserFlag ||
        userRole === "SES ADMINISTRATOR" ||
        userRole === "SYSTEMADMINISTRATOR"
    );
  }, [userSession, userRole]);

  return (
    <nav className="nav-admin" aria-label="Admin navigation">
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation menu"
      >
        <span className="navbar-toggler-icon" aria-hidden="true"></span>
      </button>

      {/*Admin Menus Begin*/}
      <div
        className="collapse navbar-collapse d-sm-inline-flex flex-sm-row-reverse text-size1"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav nav-pills flex-grow">
          {/*Dashboard Menu*/}
          <li className="nav-item">
            <Link
              to="/dashboard"
              className="nav-link text-light"
              onClick={() => {
                setSearchObj([]);
                SetSharedObject("custumerRecord", {});
              }}
            >
              <i
                className="bi bi-grid-3x3-gap sp-margin5"
               aria-hidden="true"
              ></i>
              <span className="admin-nav1">Dashboard </span>
            </Link>
          </li>
          {/*Upload Menu*/}
          <li className="nav-item dropdown">
            <button
              type="button"
              className={`nav-link dropdown-toggle text-light${isGcpUser ? " gray" : ""}`}
              id="uploadsDropdown"
              data-toggle={isGcpUser ? undefined : "dropdown"}
              aria-haspopup="true"
              aria-expanded={isGcpUser ? undefined : "true"}
              disabled={isGcpUser}
              aria-disabled={isGcpUser}
              aria-label={isGcpUser ? "Uploads - not available" : undefined}
            >
              <i
                className={`bi bi-box-arrow-in-up sp-margin5${isGcpUser ? " gray" : ""}`}
                aria-hidden="true"
              ></i>
              <span className="admin-nav1">Uploads</span>
            </button>
            {!isGcpUser && (
              <ul
                className="dropdown-menu submenu-upload-wrapper"
                aria-labelledby="uploadsDropdown"
              >
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link to={"/upload-organization"} >
                    <i
                      className="bi bi-building-up sp-margin5"
                      aria-hidden="true"
                    ></i>
                    Organizations
                  </Link>
                </li>
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link to={"/upload-org-email"} >
                    <i
                      className="bi bi-envelope sp-margin5"
                      aria-hidden="true"
                    ></i>
                    Organization Emails
                  </Link>
                </li>
                {createUser === true ||
                userRole === "SES ADMINISTRATOR" ||
                userRole === "SYSTEMADMINISTRATOR" ? (
                  <li className="nav-item nav-link d-sm-inline-flex">
                    <Link to={"/user-upload"} >
                      <img
                        className="filter-white sp-margin5 sp-margin5"
                        src={UploadUsersIcon}
                        alt=""
                        aria-hidden="true"
                      />
                      Users
                    </Link>
                  </li>
                ) : (
                  <li className="nav-item nav-link d-sm-inline-flex">
                    <span
                      className="gray"
                      disabled
                      aria-disabled="true"
                      aria-label="Upload Users - not enabled"
                      role="link"
                      tabIndex="-1"
                    >
                      <img
                        className="filter-gray sp-margin5 sp-margin5"
                        src={UploadUsersIcon}
                        alt=""
                        aria-hidden="true"
                      />
                      Users
                    </span>
                  </li>
                )}
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link to={"/upload-status"} >
                    <img
                      className="filter-white sp-margin5 sp-margin5"
                      src={UploadStatusIcon}
                      alt=""
                      aria-hidden="true"
                    />
                    Upload Status
                  </Link>
                </li>
              </ul>
            )}
          </li>
          {/*Organization Menu*/}
          <li className="nav-item dropdown">
            <button
              type="button"
              className="nav-link dropdown-toggle text-light"
              id="orgsDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i
                className="bi bi-building sp-margin5"
                aria-hidden="true"
              ></i>
              <span className="admin-nav1">Organizations</span>
            </button>
            <ul
              className="dropdown-menu submenu-org-wrapper"
              aria-labelledby="orgsDropdown"
            >
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link
                  to="/organizations"
                  onClick={() => {
                    setSearchObj([]);
                    SetSharedObject("UserIdEmail", {});
                    SetSharedObject("orgActionObj", false);
                  }}
                >
                  <i
                    className="bi bi-search sp-margin5"
                    aria-hidden="true"
                  ></i>
                  Search
                </Link>
              </li>
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link
                  to="/organization-registration"
                  onClick={() => {
                    setCustomerObj({ Type: "sub", OrgType: "org" });
                    SetSharedObject("AddOrgFlag", true);
                    SetSharedObject("CustomerPermissionsObj", {
                      Type: "sub",
                      OrgType: "org",
                    });
                  }}
                >
                  <i
                    className="bi bi-building-add sp-margin5"
                    aria-hidden="true"
                  ></i>
                  Add
                </Link>
              </li>
            </ul>
          </li>
          {/*Users Menu*/}
          <li className="nav-item dropdown">
            <button
              type="button"
              className={`nav-link dropdown-toggle text-light element${isGcpUser ? " gray" : ""}`}
              id="usersDropdown"
              data-toggle={isGcpUser ? undefined : "dropdown"}
              aria-haspopup="true"
              aria-expanded={isGcpUser ? undefined : "false"}
              disabled={isGcpUser}
              aria-disabled={isGcpUser}
              aria-label={isGcpUser ? "Users - not available" : undefined}
            >
              <i className={`bi bi-people sp-margin5${isGcpUser ? " gray" : ""}`} aria-hidden="true"></i>
              <span className="admin-nav1"> Users</span>
            </button>
            {!isGcpUser && (
              <ul
                className="dropdown-menu submenu-users-wrapper"
                aria-labelledby="usersDropdown"
              >
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link
                    to="/users"
                    onClick={() => {
                      setSearchObj([]);
                      SetSharedObject("UserIdEmail", {});
                    }}
                  >
                    <i className="bi bi-search" aria-hidden="true"></i> Search
                  </Link>
                </li>
                {createUser === true ||
                userRole === "SES ADMINISTRATOR" ||
                userRole === "SYSTEMADMINISTRATOR" ? (
                  <li className="nav-item nav-link d-sm-inline-flex">
                    <Link
                      to="/user-registration"
                      onClick={() => {
                        SetSharedObject("orgActionObj", {});
                      }}
                    >
                      <i className="bi bi-person-plus-fill" aria-hidden="true"></i> Add
                    </Link>
                  </li>
                ) : (
                  <li className="nav-item nav-link d-sm-inline-flex">
                    <span
                      className="gray"
                      disabled
                      aria-disabled="true"
                      aria-label="Add User not enabled"
                      role="link"
                      tabIndex="-1"
                      >
                      <i className="bi bi-person-plus-fill" aria-hidden="true"></i> Add
                    </span>
                  </li>
                )}
                {userRole !== "SES ADMINISTRATOR" ? null : (
                  <>
                    <li className="nav-item nav-link d-sm-inline-flex">
                      <Link
                        to="/sys-admin-registration"
                        onClick={() => {
                          SetSharedObject("orgActionObj", {});
                        }}
                      >
                        <i className="bi bi-person-fill-gear" aria-hidden="true"></i> Add SYS Admin
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            )}
          </li>
          {/*Email Menu*/}
          <li className="nav-item">
            {isGcpUser ? (
              <span
                className="nav-link text-light gray"
                aria-disabled="true"
                aria-label="Emails - not available"
                role="link"
                tabIndex="-1"
              >
                <i
                  className="bi bi-envelope sp-margin5 gray"
                  aria-hidden="true"
                ></i>
                <span className="admin-nav1">Emails</span>
              </span>
            ) : (
              <Link
                to="/emails"
                className="nav-link text-light"
                onClick={() => {
                  SetSharedObject("UserIdEmail", {});
                }}
              >
                <i
                  className="bi bi-envelope sp-margin5"
                  aria-hidden="true"
                ></i>
                <span className="admin-nav1">Emails</span>
              </Link>
            )}
          </li>
          {/*Reports*/}
          <li className="nav-item dropdown">
            <button
              type="button"
              className={`nav-link dropdown-toggle text-light${isGcpUser ? " gray" : ""}`}
              id="reportsDropdown"
              data-toggle={isGcpUser ? undefined : "dropdown"}
              aria-haspopup="true"
              aria-expanded={isGcpUser ? undefined : "false"}
              disabled={isGcpUser}
              aria-disabled={isGcpUser}
              aria-label={isGcpUser ? "Reports - not available" : undefined}
            >
              <i
                className={`bi bi-journal-medical sp-margin5${isGcpUser ? " gray" : ""}`}
                aria-hidden="true"
              ></i>
              <span className="admin-nav1">Reports</span>
            </button>
            {!isGcpUser && (
              <ul
                className="dropdown-menu submenu-reports-wrapper"
                aria-labelledby="reportsDropdown"
              >
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link
                    to="/sent-message"
                    onClick={() => {
                      SetSharedObject("sentMessageStatusResults", {});
                      SetSharedObject("messageStatusSearch", {});
                      SetSharedObject("SentSearchType", "");
                    }}
                  >
                    <i
                      className="bi bi-send-check"
                      aria-hidden="true"
                    ></i>{" "}
                    Sent Message
                  </Link>
                </li>
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link
                    to="/received-message"
                    onClick={() => {
                      SetSharedObject("recievedMessageStatusResults", {});
                      SetSharedObject("messageStatusSearch", {});
                      SetSharedObject("SentSearchType", "");
                    }}
                  >
                    <img
                      src={ReceivedMsgIcon}
                      className="filter-white sp-margin5 v-top"
                      alt=""
                      aria-hidden="true"
                    />
                    Received Message
                  </Link>
                </li>
                <li className="nav-item nav-link d-sm-inline-flex">
                  <button
                   type="button"
                   className="btn btn-link sp-pad0"
                    data-toggle="modal"
                    aria-haspopup="dialog"
                    aria-controls="UserReportSubMenu"
                    onClick={(el) => {
                      SetSharedObject("UserActiviySearch", {});
                      $("#UserReportSubMenu").modal("show");
                    }}
                  >
                    <i className="bi bi-clipboard2-data" aria-hidden="true"></i>{" "}
                    User
                  </button>
                </li>
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link to={"/download-status"} >
                    <i
                      className="bi bi-box-arrow-in-down"
                      aria-hidden="true"
                    ></i>{" "}
                    Download Status
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/*Documents*/}
          <li className="nav-item">
            <Link
              to={"/documents"}
              className="nav-link text-light"
            >
              <i
                className="bi bi-files sp-margin5"
                aria-hidden="true"
              ></i>
              <span className="admin-nav1">Docs &#38; Media</span>
            </Link>
          </li>
          {/*Customers Menu*/}
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <li className="nav-item dropdown">
              <button
                type="button"
                className="nav-link dropdown-toggle text-light"
                id="customersDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  className="bi bi-globe2 sp-margin5"
                  aria-hidden="true"
                ></i>
                <span className="admin-nav1">Customers</span>
              </button>
              <ul
                className="dropdown-menu submenu-customers-wrapper"
                aria-labelledby="customersDropdown"
              >
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link
                    to="/customers"
                    onClick={() => {
                      SetSharedObject("CustomerObj", null);
                      SetSharedObject("refreshCustObj", true);
                    }}
                  >
                    <i className="bi bi-search" aria-hidden="true"></i>{" "}
                    Search
                  </Link>
                </li>
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link to={"/customer-registration"} >
                    <i className="bi bi-plus-circle" aria-hidden="true"></i> Add
                  </Link>
                </li>
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link
                    to="/toplevel-org-registration"
                    onClick={() => {
                      SetSharedObject("orgActionObj", {});
                      setCustomerObj({
                        Type: "top",
                        OrgType: "top",
                      });
                      SetSharedObject("CustomerPermissionsObj", {
                        Type: "top",
                        OrgType: "top",
                      });
                      setCustomerFlag(false);
                      SetSharedObject("AddOrgFlag", true);
                    }}
                  >
                    <img
                      src={AddOrgCustomersIcon}
                      className="filter-white sp-margin5 v-top"
                      aria-hidden="true"
                      alt=""
                    />
                    Add Top Level Organization
                  </Link>
                </li>
              </ul>
            </li>
          )}
        </ul>
      </div>
      <SubMenuModal />
    </nav>
  );
};

export default NavAdmin;
